export class CashbackValue {
    static format (value, programLabels) {
        const formattedValue = value.toLocaleString("pt-br", {
            style: "currency",
            currency: "BRL",
            minimumFractionDigits: 2,
        });
      
        return formattedValue.replace(/\s/g, ' ');
    }
}